import { Route, Routes } from 'react-router-dom';
import Box from '@mui/material/Box';
import { FeatureHeader, DrawDownLogo, FeatureLayout } from '@lendica/components';
import { useContainerWidth } from '@lendica/hooks';
import { WithdrawalWidget, DealSummaryView } from './views';
import { MyDeals } from './components/MyDeals';

export const DrawDownView = ({
    rates,
    approval,
    placeholder,
    setWithdrawal,
    withdrawalData,
    setDealCreated,
    rate,
}) => {
    const { isNarrow } = useContainerWidth();

    const handleDealCreated = () => {
        setDealCreated(true);
    };

    return (
        <>
            <FeatureLayout>
                <Box
                    sx={{
                        pb: 4,
                        px: isNarrow ? 2 : 4,
                        pt: 2,
                        height: '100%',
                        boxSizing: 'border-box',
                    }}
                >
                    <Box sx={{ mt: 2, pb: 2, boxSizing: 'border-box' }}>
                        <FeatureHeader
                            name={<DrawDownLogo />}
                            available={approval?.funds_available ?? 0}
                            total={approval?.qualified_amount ?? 0}
                            unpaid={approval?.total_payoff_amount ?? 0}
                            entityNumber={approval?.number_of_active_deals ?? 0}
                            entity="withdrawals"
                        />
                        <WithdrawalWidget
                            approval={approval}
                            available={approval?.funds_available ?? 0}
                            withdrawalData={withdrawalData}
                            setWithdrawal={setWithdrawal}
                            gradient={false}
                            setDealCreated={handleDealCreated}
                            rate={rate}
                            rates={rates}
                        />
                        <MyDeals />
                    </Box>
                </Box>
            </FeatureLayout>

            <Routes>
                <Route path="*" element={isNarrow ? null : placeholder} />
                <Route path="deal/:dealId" element={<DealSummaryView />} />
            </Routes>
        </>
    );
};
